import {
  SET_ALUMNI,
  GET_ALUMNI,
  DELETE_ALUMNI,
  UPDATE_ALUMNI,
} from "./actionType";

export const setAlumni = (alumni) => {
  return {
    type: SET_ALUMNI,
    payload: alumni,
  };
};

export const getAlumni = (alumniData) => {
  return {
    type: GET_ALUMNI,
    payload: alumniData,
  };
};

export const deleteAlumni = (id) => {
  return {
    type: DELETE_ALUMNI,
    payload: id,
  };
};

export const updateAlumni = (updatedAlumni) => {
  return {
    type: UPDATE_ALUMNI,
    payload: updatedAlumni,
  };
};

// export const getOneNotice = (noticeOneData) => {
//   return {
//     type: GET_ONE_NOTICE,
//     payload: noticeOneData,
//   };
// };
